import { withContent, BackgroundImage } from '@bubbletea/core';
import uniqueId from 'lodash/uniqueId';
import { IContent } from '../../../types';

import Title from '../../UI/Title';
import { ExternalIcon } from '../../UI/Icons';
import Button from '../../UI/Button';
import MusicGenre from '../../Blocks/MusicGenre';

import { MusicGenreContainer, Details, Caption, GenresList } from './styles';
import sendEvent from '../../../utils/sendEvent';
import { IAdobeClickEvent } from '../../../types/tracking';

interface IMusicGenresProps {
  context: IContent;
}

const MusicGenres = ({ context }: IMusicGenresProps) => {
  const { musicGenres } = context.googlesheet;
  const { caption, title, description, genresItems, musicGenresButton } = musicGenres;

  const handleClick = () => {
    const { link, target } = musicGenresButton;
    const eventDetails = {
      location: 'song list',
      category: 'action',
      locationPosition: process.env['REACT_APP_PAGE_TYPE'] === 'subscriber' ? 4 : 7,
      action: 'view the song list',
    };
    sendEvent(eventDetails);
    if (musicGenresButton.target !== '_self') {
      window.open(link as string, target as string);
    } else {
      window.location.href = link as string;
    }
  };

  const impressionEventDetails: IAdobeClickEvent = {
    location: 'song list',
    category: 'scroll',
    locationPosition: process.env['REACT_APP_PAGE_TYPE'] === 'subscriber' ? 4 : 7,
    action: 'visible',
  };

  return (
    <MusicGenreContainer
      id={'music_genres'}
      whileInView={'sendevent'}
      onAnimationStart={() => sendEvent(impressionEventDetails, 'impressionevent')}
      viewport={{ once: true }}
    >
      <BackgroundImage imageNames={['bg-genres.png']} style={{ backgroundSize: 'cover' }} dynamic>
        <div className="section-wrapper">
          <Title uppercase>{title}</Title>
          <Details>{description}</Details>
          <GenresList>
            {genresItems.map((genreItem, index) => (
              <MusicGenre
                key={`music_genre_${uniqueId()}`}
                color={genreItem.color}
                title={genreItem.name}
                index={index}
              />
            ))}
          </GenresList>
          {musicGenresButton.title && musicGenresButton.link && (
            <Button handleClick={handleClick} type="outlined">
              {musicGenresButton.title}
              <ExternalIcon />
            </Button>
          )}
          <Caption dangerouslySetInnerHTML={{ __html: caption as string }} />
        </div>
      </BackgroundImage>
    </MusicGenreContainer>
  );
};

export default withContent(MusicGenres);
